import { render, staticRenderFns } from "./Xinxi.vue?vue&type=template&id=2cfed4bb&scoped=true&"
import script from "./Xinxi.vue?vue&type=script&lang=js&"
export * from "./Xinxi.vue?vue&type=script&lang=js&"
import style0 from "./Xinxi.vue?vue&type=style&index=0&id=2cfed4bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfed4bb",
  null
  
)

export default component.exports